const CryptoJS = require('crypto-js')

/**
 * @description base64加密
 * @param args
 * @return {*|string}
 */
export function encryptBASE64 (args) {
  const txt = CryptoJS.enc.Utf8.parse(args);
  return CryptoJS.enc.Base64.stringify(txt);
};

/**
 * @description md5加密
 * @param args
 */
export function encryptMD5 (args) {
  return CryptoJS.MD5(args).toString();
}

/**
 * @description AES加密
 * @param args
 * @param keyStr
 * @return {string}
 */
export function encryptAES (args, keyStr) {
  const key = CryptoJS.enc.Utf8.parse(keyStr);
  const encryptedData = CryptoJS.AES.encrypt(args, key, {
    iv: key,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encryptedData.ciphertext.toString();
}

/**
 * @description AES解密
 * @param args
 * @param keyStr
 * @return {string}
 */
export function decryptAES (args, keyStr) {
  const key = CryptoJS.enc.Utf8.parse(keyStr);
  const encryptedHexStr = CryptoJS.enc.Hex.parse(args);
  const encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  const decryptedData = CryptoJS.AES.decrypt(encryptedBase64Str, key, {
    iv: key,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return decryptedData.toString(CryptoJS.enc.Utf8);
}



// WEBPACK FOOTER //
// ./src/utils/encrypt.js